import { Box } from '@mui/material'
import React from 'react'
import { StyledHeader, StyledText } from '../styles'

import theme from '../../../theme'
import GenericButton from '../../../components/GenericButton'
import { ButtonSize, ButtonType } from '../../../components/GenericButton/styles'
import { useNavigate } from 'react-router-dom'
import ROUTES from '../../../consts/paths'
import { deleteLocallyStoredWizardData } from '../helper'

interface CongratulationsPageProps {
  newlyAddedTermsToProject: string[]
  setIsWizardOpen: (isOpen: boolean) => void
  setCurrPage: (page: number) => void
}

export const CongratulationsPage: React.FC<CongratulationsPageProps> = ({ setCurrPage, newlyAddedTermsToProject, setIsWizardOpen }): JSX.Element => {
  const navigation = useNavigate()

  const handleEnterTour = (): void => {
    navigation(
      `${ROUTES.COURSE_AND_ENROLLMENT}/${newlyAddedTermsToProject[0] ?? ''}`,
      { state: { openModalOnLoad: true } }
    )
    deleteLocallyStoredWizardData()
    setIsWizardOpen(false)
    setCurrPage(0) // Reset to the first page of the wizard
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center', p: theme.spacing(10) }}>
      <StyledHeader fontSize={theme.spacing(8)}>
        You are nearly finished with your survey project!
      </StyledHeader>

      <StyledText fontSize={theme.spacing(4)}>
        To complete it, visit your newly created survey project and add the desired course sections! You can also explore the survey projects page for a quick walkthrough!
      </StyledText>

      <GenericButton
        label='Enter Tour'
        variant='contained'
        buttonType={ButtonType.Primary}
        buttonSize={ButtonSize.Large}
        onClick={handleEnterTour}
      />
      <StyledText fontSize={theme.spacing(4)}>
        Missed some details? Go back and edit your project.
      </StyledText>
    </Box>
  )
}
